<template>
  <div class="tr" :class="active ? 'border-2 border-red-500' : ''" @click="highlightMe">
    <div class="td">{{ configuration.nota | prettyNote }}</div>
    <div class="td" :class="'string string-' + wire">{{ configuration.string_type | lowercase }}</div>
    <div class="td"
         v-tooltip.left="configuration.r_spina"
         :class="'spina spina-' + configuration.r_spina_descrizione_ridotta"
    >
      {{ configuration.r_spina_descrizione_ridotta }}
    </div>
    <div class="td">{{ configuration.h_spina }}</div>
    <div class="td"
         v-tooltip.left="configuration.r_capotasto"
         :class="'capotasto capotasto-' + configuration.r_capotasto_descrizione_ridotta"
         v-if="isLever"
    >
      {{ configuration.r_capotasto_descrizione_ridotta }}
    </div>
    <div class="td" v-if="isLever">{{ configuration.h_capotasto }}</div>
    <div class="td"
         v-tooltip.left="configuration.r_levetta"
         :class="'levetta levetta-' + configuration.r_levetta_descrizione_ridotta"
         v-if="isLever"
    >
      {{ configuration.r_levetta_descrizione_ridotta }}
    </div>
    <div class="td"
         v-tooltip.left="configuration.r_boccola"
         :class="'boccola boccola-' + configuration.r_boccola_descrizione_ridotta"
    >
      {{ configuration.r_boccola_descrizione_ridotta }}
    </div>
  </div>

</template>

<script>
export default {

  inject: ['stringsLayoutState'],

  props: ['configuration', 'is-lever'],

  data() {
    return {
      'rowId': this.configuration.position
    }
  },

  methods: {
    highlightMe() {
      this.stringsLayoutState.activeRow = this.rowId
    }
  },

  computed: {
    active() {
      return this.rowId == this.stringsLayoutState.activeRow
    },

    wire() {
      return this.configuration.string_type.toLowerCase().replace(' ', '-');
    }
  },

  filters: {
    prettyNote: (note) => {
      return note.replace('/', '').trim();
    },

    lowercase: (wire) => {
      return wire.toLowerCase();
    }
  }
}
</script>
